var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPolygon = function SvgPolygon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.29289 0.707106C6.68342 0.316582 7.31658 0.316583 7.70711 0.707107L13.2929 6.29289C13.6834 6.68342 13.6834 7.31658 13.2929 7.70711L7.70711 13.2929C7.31658 13.6834 6.68342 13.6834 6.29289 13.2929L0.707106 7.70711C0.316582 7.31658 0.316583 6.68342 0.707107 6.29289L6.29289 0.707106Z",
    fill: "url(#paint0_linear_865_6662)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_865_6662",
    x1: 7,
    y1: 0,
    x2: 7,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F3E47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7722"
  })))));
};
export default SvgPolygon;